import { motion } from 'framer-motion';

const EASE = [0.16, 1, 0.3, 1];

// Scroll-triggered fade + rise reveal
export const Reveal = ({ children, delay = 0, y = 40, className = '', ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-80px' }}
    transition={{ duration: 0.8, ease: EASE, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal for large headlines.
// Pass an array of strings (each = one visual line).
export const MaskedLines = ({ lines, className = '', delay = 0.15, onLoad = false }) => {
  const parentProps = onLoad
    ? { initial: 'hidden', animate: 'visible' }
    : { initial: 'hidden', whileInView: 'visible', viewport: { once: true, margin: '-80px' } };

  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className="block"
            variants={{ hidden: { y: '110%' }, visible: { y: 0 } }}
            transition={{ duration: 0.9, ease: EASE, delay: delay + i * 0.12 }}
            {...parentProps}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
